import { IconRefresh } from "@tournated-com/ui";

import { useT } from "@/i18n";

import { ErrorPage, ErrorPageButton } from "../ui/ErrorPage";

export const DynamicImportErrorPage = () => {
  const t = useT();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorPage
      documentTitle={t("general.components.dynamicImportErrorPage.title")}
      icon={IconRefresh}
      title={t("general.components.dynamicImportErrorPage.heading")}
      description={
        <>
          <p>{t("general.components.dynamicImportErrorPage.description1")}</p>
          <p>{t("general.components.dynamicImportErrorPage.description2")}</p>
        </>
      }
      actions={
        <ErrorPageButton size="lg" onPress={handleRefresh}>
          {t("general.actions.refreshPage")}
        </ErrorPageButton>
      }
    />
  );
};
